<template>
    <div>
        <b-navbar toggleable="lg" type="dark" fixed="top" variant="default" style="background-color: #563d7c;">
            <b-navbar-brand href="#" id="colegio"><b-img :src="escudo" rounded="circle" width="40" fluid></b-img></b-navbar-brand>
            <b-popover target="colegio" triggers="hover" placement="top">
                <template v-slot:title>Información General</template>
                {{datosSesion.categoria}}<br><b>{{datosSesion.nombre}}</b><hr>
                Año Lectivo<br><h1>{{datosSesion.lectivo}}</h1>
            </b-popover>
            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav>
                <b-navbar-nav>
                    <b-nav-item :to="{name: 'Home'}" exact>Inicio</b-nav-item>
                    <b-nav-item-dropdown text="Secretaria" left class="ml-2">
                        <b-dropdown-item :to="{name: 'About'}">Constancias</b-dropdown-item>
                        <b-dropdown-item href="#">Certificados</b-dropdown-item>
                        <b-dropdown-item href="#">Paz y Salvos</b-dropdown-item>
                    </b-nav-item-dropdown>
                    <b-nav-item-dropdown text="Matriculas" left class="ml-2">
                        <b-dropdown-item href="#">Nueva Matricula - Renovar Matricula</b-dropdown-item>
                        <b-dropdown-item href="#">Renovar Matricula</b-dropdown-item>
                        <b-dropdown-item href="#">Cupos</b-dropdown-item>
                    </b-nav-item-dropdown>
                </b-navbar-nav>

                <b-navbar-nav class="ml-auto">
                    <b-nav-item-dropdown right>
                        <template v-slot:button-content>
                            <b-img :src="foto" width="30" fluid></b-img>
                        </template>
                        <b-dropdown-item variant="dark" :to="{name: 'Perfil'}">
                            <b-icon-person-fill></b-icon-person-fill> Perfil de<br><b>{{datosSesion.nombres}} {{datosSesion.idPerfil}}</b>
                        </b-dropdown-item>
                            <hr>
                        <b-dropdown-item variant="danger" v-b-modal.modal-salir>
                            <b-icon-x-circle></b-icon-x-circle> Salir de Sised
                        </b-dropdown-item>
                    </b-nav-item-dropdown>
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>
        <b-modal id="modal-salir" title="Salir de Sised" header-bg-variant="danger" header-text-variant="light">
            <p class="text-center my-2" style="font-size: 80px; color: red"><b-icon-x-circle></b-icon-x-circle></p>
            <p class="text-center my-2">Está seguro que desea cerrar la sesión?</p>
            <template slot="modal-footer" slot-scope="{ cancel }">
                <b-button class="px-5" size="sm" variant="danger" @click="salir">Salir</b-button>
                <b-button class="px-2" size="sm" variant="default" @click="cancel()">Cancelar </b-button>
            </template>
        </b-modal>
    </div>
</template>
<script>
    import {mapState} from 'vuex'

    export default {
        data() {
            return {
                escudo: '',
                foto: ''
            }
        },
        methods: {
            salir() {
                this.$router.push("/login")
            }
        },
        beforeMount() {
            this.escudo = require('@/assets/escudos/es' + this.datosSesion.idColegio + '.jpg')
            this.foto = require('@/assets/colegios/' + this.datosSesion.bd + '/fotos/avatar.jpg')
        },
        computed: {
            ...mapState(['datosSesion'])
        }
    }
</script>